import React, { Component } from 'react';
import PropTypes from 'prop-types';

import { converter } from '../../../../helpers/converter';

export default class DateButton extends Component {
  static propTypes = {
    metadata: PropTypes.object,
    translations: PropTypes.object,
    params: PropTypes.object,
  };

  render() {
    const { metadata, translations, params } = this.props;

    if (typeof metadata.live_ppe_available === 'undefined') {
      return null;
    }

    let ppeAva = null;
    try {
      ppeAva = JSON.parse(metadata.live_ppe_available);
      const liveLabel = converter.convertApaUnicode(
        translations,
        ppeAva[params.id],
        'Disponible Pronto',
      );
      return (
        <button className="btn btn-default btn-lg primary">{liveLabel}</button>
      );
    } catch (e) {
      console.log('unable to parse', metadata.live_ppe_available);
      return null;
    }
  }
}
